import useApi, { ApiOptions } from '../base/useApi';
import UserInfoDTO from '@src/adapters/dto/user/UserInfoDTO';

interface Params {}

interface Result {
  items: UserInfoDTO[];
}

const options: ApiOptions = {
  method: 'get',
  urlPath: '/user/active/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useFindUsersActiveLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useFindUsersActiveLazy;
